import { defineComponent as t, openBlock as l, createBlock as n, unref as r, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconMove",
  __name: "IconMove",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (i, e) => (l(), n(r(s), p(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "m12.75 4.81.72.72a.75.75 0 1 0 1.06-1.06l-1.646-1.647a1.25 1.25 0 0 0-1.768 0L9.47 4.47a.75.75 0 0 0 1.06 1.06l.72-.72v6.44H4.81l.72-.72a.75.75 0 1 0-1.06-1.06l-1.647 1.646a1.25 1.25 0 0 0 0 1.768L4.47 14.53a.75.75 0 0 0 1.06-1.06l-.72-.72h6.44v6.44l-.72-.72a.75.75 0 1 0-1.06 1.06l1.646 1.647a1.25 1.25 0 0 0 1.768 0l1.646-1.647a.75.75 0 0 0-1.06-1.06l-.72.72v-6.44h6.44l-.72.72a.75.75 0 1 0 1.06 1.06l1.647-1.646a1.25 1.25 0 0 0 0-1.768L19.531 9.47a.75.75 0 0 0-1.061 1.06l.72.72h-6.44V4.81" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
